import { useNavigate } from 'react-router-dom'
import { IconButton, Typography, Paper } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faXmark } from '@fortawesome/free-solid-svg-icons'
import { getRoutePath } from '../../routes/routes'
import { useContext } from 'react'
import { LayoutContext } from '../LayoutSingleAction'

function BreadCrumb(_props) {
  const {
    layoutState,
  } = useContext(LayoutContext)

  const { parentRouteName, title, isFullscreen } = layoutState

  const navigate = useNavigate()
  const handleBack = () => {
    Boolean(parentRouteName)
      ? navigate(getRoutePath(parentRouteName), { replace: true })
      : navigate(-1, { replace: true })
  }

  const classes = isFullscreen
    ? `fixed bg-bg bg-opacity-50 justify-between backdrop-blur-sm`
    : `bg-transparent absolute justify-end`

  return (
    <Paper
      elevation={isFullscreen ? 6 : 0}
      className={`text-primary px-8 py-6 top-0 left-0 z-10 w-full flex flex-row items-center rounded-none ${classes}`}
    >
      {isFullscreen && (
        <>
          <IconButton onClick={handleBack} color="primary">
            <FontAwesomeIcon icon={faArrowLeft} fixedWidth />
          </IconButton>
          <Typography variant="h1" component={'div'}>
            {title}
          </Typography>
        </>
      )}
      <IconButton onClick={handleBack} color="primary">
        <FontAwesomeIcon icon={faXmark} fixedWidth />
      </IconButton>
    </Paper>
  )
}

export default BreadCrumb
